import React from "react";
import { ToastContainer as ToastDIV } from "react-toastify";

const ToastContainer = ({ position = "top-right", autoClose = 2000 }) => (
	<ToastDIV
		position={position}
		autoClose={autoClose}
		hideProgressBar={false}
		newestOnTop={true}
		closeOnClick
		rtl={false}
		pauseOnFocusLoss
		draggable
		pauseOnHover
		theme="light"
	/>
);

export default ToastContainer;
